const SearchXIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="84"
    height="84"
    viewBox="0 0 84 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M47.25 29.75L29.75 47.25"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.75 29.75L47.25 47.25"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.5 66.5C53.964 66.5 66.5 53.964 66.5 38.5C66.5 23.036 53.964 10.5 38.5 10.5C23.036 10.5 10.5 23.036 10.5 38.5C10.5 53.964 23.036 66.5 38.5 66.5Z"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M73.4999 73.4999L58.45 58.45"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const NoData = () => {
  return (
    <div className="w-full flex items-center justify-center gap-4">
      <SearchXIcon className="w-10 h-10 stroke-[#828282]" />
      <div className="text-[14px] font-light text-[#4F4F4F]">No hay resultados</div>
    </div>
  )
}

export { NoData }
